export const SET_SEARCH_TEXT = 'searchText';
export const SET_ONLY_PADRAO = 'onlyPadrao';
